module.exports = __webpack_public_path__ + "img/alert-triangle.fc8aba7f.svg";